import React from "react";
import { PeekTypography, useTheme } from "@piiqtechnologies/ui-components";
export const NavigationTitle = ({ content, isUpperCase = false }) => {
    const theme = useTheme();
    return (React.createElement(PeekTypography, { color: theme.palette.grey[400], textTransform: isUpperCase ? "uppercase" : "capitalize", variant: "body1", fontWeight: theme.typography.fontWeightMedium }, content));
};
export default NavigationTitle;
